export const NEW_PARTNER_NAME = '{newPartnerName}'
export const NEW_ADVERTISER_NAME = '{newAdvertiserName}'
